import type { z } from 'zod';

import type { VideoSchema } from './schemas';

type VideoField = keyof z.infer<typeof VideoSchema>;

const listAttributes = [
  'subject',
  'id',
  'categoryCode',
  'topicCode',
  'topicId',
  'youtubeId',
  'playbackProvider',
  'topicResources',
  'title',
  'description',
  'creationDatetime',
  'resources',
  'topicVideos',
  'relatedVideos',
  'pathLabels',
  'hostName',
] as const satisfies readonly VideoField[];

/**
 * The list is readable by any signed-in user, so the provider's own identifier
 * is kept to the single-video read the permission check guards.
 */
const getAttributes = [...listAttributes, 'gumletAssetId'] as const satisfies readonly VideoField[];

const searchAttributes = ['title'] as const satisfies readonly VideoField[];

const updateAttributes = [
  'title',
  'description',
  'hostName',
  'youtubeId',
  'relatedVideos',
  'resources',
] as const satisfies readonly VideoField[];

/**
 * What a Gumlet source replacement writes. `playbackProvider` is in the list so
 * the encoder sees a whole source, not a bare asset ID.
 */
const sourceAttributes = [
  'playbackProvider',
  'gumletAssetId',
] as const satisfies readonly VideoField[];

export const VideoAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Search: searchAttributes,
  Update: updateAttributes,
  Source: sourceAttributes,
};
